module.exports = __webpack_public_path__ + "static/media/md-basket.609963fa.svg";